import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Input,
  NgModule,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lp2-radio',
  template: `
  <div [class]="inputClass">
    <input #radio class="input" type="radio" 
      [name]="name" 
      [value]="value"
      [id]="id"
      (change)="onChange($event.target.value)"
      (click)="onTouch($event.target.value)"
    >
    <div class="label">
      <i class="icon fa fa-check"></i>
    </div>
  </div>
  `,
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ]
})
export class RadioComponent implements ControlValueAccessor {
  @ViewChild('radio') private _radioInput: ElementRef<HTMLInputElement>;

  private _value: string;

  @Input() public name: string = '';

  @Input() public label: string = '';

  @Input() public value: string = '';

  @Input() public set checked(val: boolean) {
    this._radioInput.nativeElement.checked = val;
  }
  public get checked(): boolean {
    return this._radioInput.nativeElement.checked;
  }

  @Input() public id: string;

  @Input() public size: 'small' | 'large' = 'large';

  @Input() public type: 'primary' | 'secondary' | 'light' = 'primary';

  public get inputClass() {
    return `radio radio--${this.size} radio--${this.type}`;
  }

  public onChange: any = (value: any) => value;
  public onTouch: any = (value: any) => value;

  public writeValue(value: any): void {
    this._value = value;
    if (this.value === this._value) {
      this.checked = true;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public check(): void {
    this._radioInput.nativeElement.click();
  }
}

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  exports: [RadioComponent, ReactiveFormsModule, FormsModule],
  declarations: [RadioComponent],
})
export class RadioModule { }


// WEBPACK FOOTER //
// ./ts/app/shared/radio/radio.component.ts